import { BaseModel, TestExecution } from '..'

export class TestExecutionRecord extends BaseModel {
  public data: {} = {}
  public execution: TestExecution

  public getData(key: string, defaultValue?: any) {
    return this.data.hasOwnProperty(key) ? this.data[key] : defaultValue
  }

  public setDataMethod(key: string, value: any) {
    return this.data[key] = value
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test-execution-record/test-execution-record.ts